<template>
    <v-container class="context-check-container" fluid>
        <v-layout align-center justify-start column fill-height>
            <v-flex class="top-logo">
                <img v-if="tenant.logo" class="logo" :src="tenant.logo" />
                <img v-else class="logo" src="@/assets/logo-w.png" />
            </v-flex>
            <v-flex xs12>
                <v-card class="context-check">
                    <h2 class="primary--text">{{ tenant.appName || appname }}</h2>
                    <h3 class="grey--text">{{ slogan }}</h3>
                    <div class="main-text">
                        <p v-if="passed">加载中</p>
                        <div v-else>
                            <p style="color:red"><v-icon large color="red">warning</v-icon> 系统提示</p>
                            <p>您当前用微信打开了平台，部分功能可能无法使用。<br />
                                请复制平台网址，在电脑浏览器中打开。</p>
                            <p>{{ url }}</p>
                            <p v-if="canCopy"><v-btn color="primary" round @click="onCopyUrl" style="width: 120px;">{{
                                copyText
                            }}</v-btn></p>
                            <p v-else>浏览器不支持剪切板功能，请直接复制以上网址～</p>
                        </div>
                    </div>
                    <div style="color: #888;margin-top: 8px;" v-if="!passed">
                        <v-divider />
                        <p>
                            建议您下载和使用如下浏览器，以增强使用体验：<br />
                            <img style="width:40px" src="../assets/chrome-logo.jpg" /> <br />
                            Google Chrome <br />
                            <v-btn color="primary" round href="https://www.google.cn/intl/zh-CN/chrome/">下载</v-btn>
                        </p>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
export default {
    name: "context-check",
    data: function () {
        return {
            appname: this.$const.appName,
            slogan: this.$const.slogan,
            passed: true,
            canCopy: false,
            url: null,
            copyText: '复制平台网址'
        };
    },
    computed: {
        tenant() {
            return this.$store.state.tenant;
        },
    },
    methods: {
        onCopyUrl() {
            let self = this;
            navigator.clipboard.writeText(self.url).then(() => {
                self.copyText = '复制成功';
                setTimeout(() => {
                    self.copyText = '复制平台网址';
                }, 5000);
            }).catch(() => {
                self.canCopy = false;
            });

        }
    },
    created() {
        let self = this, loc = window.location, q = self.$query(), qs = q ? self.$qs.stringify(q) : '';
        self.url = `${loc.protocol}//${loc.hostname}${(!loc.port || loc.port == 443 || loc.port == 80) ? '' : (':' + loc.port)}/s/a/${qs.length > 0 ? ('?' + qs) : ''}`;

        if (typeof navigator === 'object') {
            if (typeof navigator.clipboard === 'object') {
                self.canCopy = true;
            }
            if (navigator.userAgent && navigator.userAgent.indexOf('MicroMessenger') != -1) {
                self.passed = false;
                return;
            }
        }
        self.passed = true;
        if (q && q.sign) {
            //api授权登录
            self.$axios
                .post("/login", self.$qs.stringify({ ...q, _t: 3 }))
                .then((r) => {
                    if (r && r.data && r.data.status === "ok") {
                        self.$store.commit("account", r.data.message);
                        self.$router.push("/console");
                    }
                });
            return;
        }
        //加入单点登录的逻辑
        self.$axios
            .get("/home/my/a/info")
            .then((r) => {
                if (r && r.status == 200) {
                    self.$store.commit("account", r.data.message);
                    let hash = window.location.hash;
                    if (hash.indexOf("#/console") != 0) {
                        self.$router.push("/console");
                    }
                }
            })
            .catch(() => {
                //ignore.
            });
    }
};
</script>
<style scoped>
.context-check-container {
    background: var(--v-primary-base);
}

.top-logo {
    flex-grow: 0;
    margin-top: 36px;
}

.top-logo img.logo {
    height: 30px;
    width: auto;
    display: inline-flex;
}

.context-check {
    max-width: 600px;
    text-align: center;
    padding: 40px 65px;
    margin-top: 40px;
}

.context-check h2 {
    font-size: 24px;
    line-height: 1;
}

.context-check h3 {
    font-size: 16px;
    font-weight: normal;
    margin-top: 20px;
}

.context-check p {
    margin-top: 20px;
    margin-bottom: 0;
}

.main-text {
    font-size: 18px;
}
</style>